import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import {
    showNotification,
    UPDATE,
    withDataProvider,
} from 'react-admin';
import { push } from 'react-router-redux';

class ApproveButton extends Component {
    handleClick = () => {
        const {dataProvider, dispatch, record} = this.props;

        record.approved_at = new Date();

        const updatedRecord = {...record};
        dataProvider(UPDATE, 'posts', {id: record.id, data: updatedRecord})
            .then(() => {
                dispatch(showNotification('comments.post.approved.success', 'info'));
                dispatch(push('/posts'));
            })
            .catch((e) => {
                dispatch(showNotification('comments.post.approved.error.general', 'warning'))
            });
    }

    render() {
        return <Button size="small" color="primary" variant="outlined" label="Approve" onClick={this.handleClick}>Approve</Button>;
    }
}

ApproveButton.propTypes = {
    dataProvider: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    record: PropTypes.object,
};

export default withDataProvider(ApproveButton)